// extracted by mini-css-extract-plugin
export default {"device":"index_device__l9IPU","box":"index_box__Qg46p"};